export default `
	query scheduleItemsReport($date:AWSDate!, $remindManually:Boolean!, $nextToken:String){
			scheduleItemsReport(date:$date,remindManually:$remindManually,nextToken:$nextToken){
					nextToken
					items{
					docId
					creationTimestamp
					itemId
					fromTimestamp
					toTimestamp
					clinic
					reminders{
						email{
							lastSentTimestamp
							lastStatus
						}
						sms{
							lastSentTimestamp
							lastStatus
						}
					}
					patient{
						name{
							firstName
							lastName
						}
						email
						mobile{
							countryPrefixCode
							mobileNumber
						}
						landline{
							countryPrefixCode
							landlineNumber
						}
						idCard
						dob
						remindManually
					}
					}
				}
			}
		`